import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/react-query';
import { Team } from '@/types';

import { PasswordFormValues } from '../components/team-settings/password-update-form';

export const updateTeamPassword = ({
  teamId,
  data,
}: {
  teamId: string;
  data: PasswordFormValues;
}): Promise<Team> => {
  return api.patch(`/teams/${teamId}/password`, data, {
    withCredentials: true,
  });
};

type UseUpdateTeamPasswordOptions = {
  mutationConfig?: MutationConfig<typeof updateTeamPassword>;
};

export const useUpdateTeamPassword = ({
  mutationConfig,
}: UseUpdateTeamPasswordOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: updateTeamPassword,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['users', 'teams'],
      });
      onSuccess?.(...args);
    },
    ...restConfig,
  });
};
